import React from "react";
import { Field } from "formik";
import { Formik } from "formik";
import AllStates from "../../AllStates";
import { Button } from "rsuite";
class AgencyMainModal extends React.Component {
  render() {
    let submitText = "submit";
    // let saveText = "save";

    switch (this.props.mode) {
      case 0:
        submitText = "Save Draft";
        break;
      case 1:
        submitText = "Submit Draft";
        break;
      case 2:
        submitText = "Approve Submission";
        break;
      case 3:
        submitText = "Update Submission";
        break;
      default:
        break;
    }
    return (
      <div>
        <Formik
          onSubmit={values => {
            if (!values.state_id) {
              values.state_id = 1;
            }
            this.props.submit(values);
          }}
          initialValues={this.props.shownItem}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <fieldset
                disabled={this.props.disabled}
              >
                {this.props.disabled ? null : (
                    <div style={{textAlign: "right"}}>
                      <Button
                          className="mt-1"
                          type="submit"
                          color="blue"
                          disabled={
                            isSubmitting ||
                            (localStorage.getItem("project_role").includes("USER") &&
                                (this.props.mode === 2 ||
                                    (this.props.mode === 3 &&
                                        this.props.shownItem.created_by !==
                                        localStorage.getItem("id"))))
                          }
                      >
                        {" "}
                        {submitText}{" "}
                      </Button>
                    </div>
                )}
                <div>
                  <h1>Basic Information</h1>
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    <input
                      type="text"
                      name="agency_id"
                      onChange={handleChange}
                      className="form-control"
                      value={values.agency_id}
                      onBlur={handleBlur}
                      disabled
                      hidden
                    />
                  </label>
                </div>
                <small className={"d-block"}>
                  <span style={{ color: "red" }}>*</span> required
                </small>
                <div className="form-row">
                  <label htmlFor="state" className="required col-sm-3">
                    State
                  </label>
                  <select
                    required
                    className="form-control col-sm-3"
                    id="state_id"
                    name="state_id"
                    value={values.state_id}
                    onChange={handleChange}
                  >
                    {AllStates.map(state => (
                      <option key={state.state_id} value={state.state_id}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-row">
                  <label className="required col-sm-3">Agency Name</label>
                  <input
                    style={{ width: "400px" }}
                    type="text"
                    required
                    maxLength={60}
                    name="agency_name"
                    onChange={handleChange}
                    className="form-control col-sm-6"
                    value={values.agency_name}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Agency Short Name</label>
                  <input
                    type="text"
                    maxLength={30}
                    name="agency_short_name"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    value={values.agency_short_name}
                    onBlur={handleBlur}
                  />
                </div>

                <div className="form-row">
                  <label className="col-sm-3">Agency Division</label>
                  <input
                    type="text"
                    name="agency_division"
                    onChange={handleChange}
                    className="form-control col-sm-6"
                    value={values.agency_division}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Agency Website</label>
                  <input
                      type="text"
                      name="agency_website"
                      onChange={handleChange}
                      className="form-control col-sm-6"
                      value={values.agency_website}
                      onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Office Name</label>
                  <input
                    type="text"
                    name="office_name"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    value={values.office_name}
                    onBlur={handleBlur}
                  />
                </div>

                <div className="form-row">
                  <label className="col-sm-3">Employees Number</label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_employees"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    value={values.num_employees}
                    onBlur={handleBlur}
                  />{" "}
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Operational P3 Procurements</label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_opretional_p3_procurements"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    value={values.num_opretional_p3_procurements}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Under Construction P3 Procurements
                  </label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_under_construction_p3_procurements"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    value={values.num_under_construction_p3_procurements}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Projects Procurement Phase</label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_projects_procurement_phase"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.num_projects_procurement_phase}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Projects Development Phase</label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_projects_development_phase"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.num_projects_development_phase}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">P3 Projects Pipeline</label>
                  <input
                    type="number"
                    maxLength={11}
                    name="num_p3_projects_pipeline"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.num_p3_projects_pipeline}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Sponsor Total Budget($Mil)</label>
                  <input
                    type="text"
                    name="sponsor_total_budget"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.sponsor_total_budget}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Budget Year</label>
                  <input
                    type="number"
                    maxLength={9}
                    name="budget_year"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.budget_year}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Capital Project Budget($Mil)
                  </label>
                  <input
                    type="number"
                    maxLength={11}
                    name="capital_project_budget"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.capital_project_budget}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Contract Consultants Project Screening
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="contract_consultants_project_screening"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Contract Consultants Financing Plans
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="contract_consultants_financing_plans"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Contract Consultants VFM</label>
                  <Field
                    className="form-control col-sm-6"
                    name="contract_consultants_vfm"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Contract Consultants Risk Analysis
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="contract_consultants_risk_analysis"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Contract Consultants Engineering Design
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="contract_consultants_engineering_design"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">External Advisers</label>
                  <Field
                    className="form-control col-sm-6"
                    name="external_advisers"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Formal Predures Assessing Best Fit Delivery Methods
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="formal_predures_assessing_best_fit_delivery_methods"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Annual Debt Capacity</label>
                  <Field
                    className="form-control col-sm-6"
                    name="annual_debt_capacity"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Financial Self Sufficiency Toll Requirements
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="financial_selfsufficiency_toll_reqs"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Public Funding Support Toll Facility
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="public_funding_support_toll_facility"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Toll Rate Setting Policies</label>
                  <Field
                    className="form-control col-sm-6"
                    name="toll_rate_setting_policies"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Formal Procedures For Tolling New And Existing Highway
                    Capacity
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="formal_procedures_for_tolling_new_and_existing_highway_capacity"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">
                    Centralized VS Decentralized Management Process
                  </label>
                  <Field
                    className="form-control col-sm-6"
                    name="centralized_vs_decentralized_management_process"
                    component="textarea"
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Data Collection Year</label>
                  <input
                    type="number"
                    maxLength={4}
                    name="data_collection_year"
                    className="form-control col-sm-6"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="form-row">
                  <label className="col-sm-3">Note</label>
                  <Field
                    className="form-control col-sm-6"
                    name="notes"
                    component="textarea"
                  />
                </div>
              </fieldset>
              {this.props.disabled ? null : (
                  <Button
                      className="my-2"
                      type="submit"
                      color="blue"
                      disabled={
                        isSubmitting ||
                        (localStorage.getItem("project_role").includes("USER") &&
                            (this.props.mode === 2 ||
                                (this.props.mode === 3 &&
                                    this.props.shownItem.created_by !==
                                    localStorage.getItem("id"))))
                      }
                  >
                    {" "}
                    {submitText}{" "}
                  </Button>
              )}
            </form>
          )}
        </Formik>
      </div>
    );
  }
}

export default AgencyMainModal;
